import React from 'react';

const noDataMsg = () => (
    <div className="text-center pt-4 pb-4">
        {/* <span className="no_data_icon"><SocialSentimentVeryDissatisfied/></span> */}
        <h4 className="mt-1 pt-0 pb-0 pl-4 pr-4 light_grey size_2rem">No Data was found for the selected date range</h4>
        <h6 className="light_grey">Please change your search terms and try again.</h6>
    </div>
);

export default noDataMsg;